import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { RadioGroup } from "@headlessui/react";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import queryString from "query-string";
import CryptoJS from 'crypto-js';
import { toast } from "react-toastify";
import ProductDetailsComponent from "../components/Product-details.component";
import LocationComponent from "../components/location.component";
import ScheduleComponent from "../components/schedule.component";
import ConfirmComponent from "../components/confirm.component";
import { RotatingLines } from "react-loader-spinner";
import { selectCurrent } from "../../../../redux/settings/selectors";
import { selectOrdersCreatedItem } from "../../../../redux/orders/selector";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectQuotesCreatedItem } from "../../../../redux/quotes/selector";
import { selectCmsSettingsListItems } from "../../../../redux/cmsSettings/selector";
import { quotes } from "../../../../redux/quotes/action";
import { settings } from "../../../../redux/settings/actions";
import storePersist from "../../../../redux/storePersist";
import { addPayment } from "../../../../redux/addPayment/action";
import { orders } from "../../../../redux/orders/action";
import { shippingTypes } from "../../../../redux/shippingTypes/action";
//import { leads } from "../../../../redux/leads/action";
import { selectShippingTypesListItems } from "../../../../redux/shippingTypes/selector";
import { selectCategoriesListItems } from "../../../../redux/categories/selector";
import { categories } from "../../../../redux/categories/action";
import { selectProductsListItems } from "../../../../redux/products/selector";
import useWindowDimensions from "../../../../hooks/useWindowsDimensions";
import { paymentMethods } from "../../../../redux/payment-methods/action";
import { selectPaymentMethodsQueryItems } from "../../../../redux/payment-methods/selector";
import { channel } from "../../../../redux/channel/action";
import { selectSubCategoriesListItems } from "../../../../redux/sub-categories/selector";
import { selectProductTypesListItems } from "../../../../redux/product-types/selector";
import { subCategories } from "../../../../redux/sub-categories/action";
import { productTypes } from "../../../../redux/product-types/action";
import { selectLeadsCreatedItem } from "../../../../redux/leads/selector";

declare let Razorpay: any;
let currentChange: any = {};
const HomeOrderBookings = () => {

	interface ISteps {
		CategoryName: string;
		ItemName: string
		PackageType: string
		Weight: string
		Width: string
		Height: string
		Length: string
		AdditionalInfo: string
		NumberOfItems: number
	}
	const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
	const dispatch = useAppDispatch();
	const result = useSelector(selectCurrent)
	const [isQuotes, setIsQuotes] = useState<boolean>(false)
	const createLead = useSelector(selectLeadsCreatedItem)
	const quoteDetails = useSelector(selectQuotesCreatedItem)
	const paymentSettings = useSelector(selectCmsSettingsListItems)
	const categoryListItems = useSelector(selectCategoriesListItems)
	const productTypesitemsData = useSelector(selectProductTypesListItems)
	const subCategoryListItems = useSelector(selectSubCategoriesListItems)
	const [isPaymentAdded, setIsPaymentAdded] = useState<any>(false);
	const [quoteData, SetQuoteData] = useState<any>({});
	const navigate = useNavigate()
	//const [leadValues, setLeadValues] = useState<any>()
	const [generateIds, setGenerateIds] = useState<any>([]);
	const productListData = useSelector(selectProductsListItems)
	const paymentMethodQuery = useSelector(selectPaymentMethodsQueryItems)
	const shippingTypesDetails = useSelector(selectShippingTypesListItems)
	const [productItems, setProductItems] = useState<any>([]);

	const handleChange: any = (event: any, field: string) => {
		//setLeadValues({ ...leadValues, [field]: event })
		setProductItems({ ...productItems, [field]: event })
		SetQuoteData({ ...quoteData, [field]: event })
	}
	const parentCategories = categoryListItems?.result?.items.filter(
		(subCategoryData: any) => subCategoryData.IsSubCategory === false
	)
	const [paymentGateway, setPaymentGateway] = useState<any>([]);
	const [razorpaySettings, setRazorpaySettings] = useState<any>([])
	const [isOrderPlaced, setIsOrderPlaced] = useState<any>(false);
	const { height, width } = useWindowDimensions();
	const orderDetails = useSelector(selectOrdersCreatedItem)
	var tenantId = storePersist.get('guestTokenMetadata')?.current?.result?.TokenMetadata?.TenantId
	const MODE = 'secure';
	var salesChannelId = storePersist?.get("queryByStore")?.current[0]?.SalesChannelId;
	var storeId = storePersist?.get("queryByStore")?.current[0]?.StoreId;
	const [count, setCount] = useState(1)
	const [SearchedLocation, setSearchedLocation] = useState<any>({
		name: result?.searchedLocation?.name || '',
		lat: result?.searchedLocation?.lat || '',
		lng: result?.searchedLocation?.lng || '',
		pincode: result?.searchedLocation?.pincode || '',
		description: result?.searchedLocation?.description || '',
	});
	const [dropLocations, setDropLocations] = useState<any>({
		name: result?.searchedToLocation?.name || '',
		lat: result?.searchedToLocation?.lat || '',
		lng: result?.searchedToLocation?.lng || '',
		pincode: result?.searchedToLocation?.pincode || '',
		description: result?.searchedToLocation?.description || '',
	});
	//const [isLead, setIsLead] = useState<boolean>(false)
	const [selectedInput, setSelectedInput] = useState("");
	const PackageType = [
		{ name: 'Standard Package' },
		{ name: 'Custom Package' }
	]





	const items = [
		{
			name: 'Cash',
			description: 'Cash on delivery',
			value: 10,
			checked: '',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForCOD,
		},
		{
			name: 'Online',
			description: 'Payment gateway',
			value: 20,
			checked: 'checked',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForOnline,
		},
		{
			name: 'Wallet',
			description: 'Wallet',
			value: 40,
			checked: '',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForWallet,
		},
	];

	const [selected, setSelected] = useState(items[0].value);





	const generateUniqueId = () => {
		const randomPart = Math.random().toString(36).substr(2, 9); // Random part
		const timestampPart = Date.now().toString(36); // Timestamp part
		return `${randomPart}-${timestampPart}`;
	};

	const generateIdValue = () => {
		const newItem = {
			transaction_id: generateUniqueId(),
			message_id: generateUniqueId(),
			fulfillment_id: generateUniqueId(),
			item_id: generateUniqueId(),
			order_id: generateUniqueId(),
		};
		setGenerateIds(newItem);
	};
	const userInfo = storePersist?.get("userProfile")?.current?.items;


	const tutorialSteps = [

		{
			id: 1,
			title: 'Product Details',
			subTitle: 'Product Details',
			component: (
				<ProductDetailsComponent
					productItems={productItems}
					productTypesitemsData={productTypesitemsData}
					categoryListItems={categoryListItems}
					parentCategories={parentCategories}
					subCategoryListItems={subCategoryListItems}
					handleChange={handleChange}
				/>

			),
			display: true,
		},
		{
			id: 2,
			title: 'Location Details',
			subTitle: 'Pickup Details',
			component: (
				<LocationComponent
					dropLocations={dropLocations}
					setDropLocations={setDropLocations}
					quoteData={quoteData}
					SearchedLocation={SearchedLocation}
					setSearchedLocation={setSearchedLocation}
					handleChange={handleChange}
				/>

			),
			display: true,
		},
		{
			id: 3,
			title: 'Schedule Date',
			subTitle: 'Delivery Schedule',
			component: (
				<ScheduleComponent
					quoteData={quoteData}
					handleChange={handleChange}
				/>

			),
			display: true,
		},
		{
			id: 4,
			title: 'Confirm Booking',
			subTitle: 'Order Summary',
			component: (
				<ConfirmComponent
					quoteData={quoteData}
					quoteDetails={quoteDetails} />
			),
			display: true,
		},
		{
			id: 5,
			title: 'Payment Option',
			subTitle: 'Select payment slot',
			component: (
				<div className="block">
					<div className="mt-2">
						<RadioGroup
							value={selected}
							onChange={setSelected}
							className="md:grid md:grid-cols-2 md:gap-5 auto-rows-auto space-y-4 md:space-y-0"
						>
							{items?.length > 0 ? (
								items?.map(
									(item: any, index: any) =>
										item.show && (
											<RadioGroup.Option
												key={index}
												value={item.value}
												className={({ checked }) =>
													`${checked ? ' border-blue-800' : ' border-blue-400'}
                    border-2 relative shadow-md focus:outline-none rounded-md p-5 block cursor-pointer min-h-[112px] h-full group address__box`
												}
											>
												<RadioGroup.Label
													as="h3"
													className=" font-semibold mb-2 -mt-1"
												>
													{item?.name}
												</RadioGroup.Label>
												<RadioGroup.Description
													as="div"
													className="  leading-6"
												>
													{item?.description}
												</RadioGroup.Description>
											</RadioGroup.Option>
										),
								)
							) : (
								<div className="border-2 border-skin-base rounded font-semibold p-5 px-10 text-skin-ouprimary flex justify-start items-center min-h-[112px] h-full">
									No payment option found
								</div>
							)}
						</RadioGroup>
					</div>
				</div>
			),
			display: true,
		},
	];

	const [activeStep, setActiveStep] = useState(0);
	const maxSteps = tutorialSteps.length;
	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	useEffect(() => {
		dispatch(subCategories.resetAction({ actionType: 'list' }))
		if (productItems?.CategoryName) {
			const CategoryName = categoryListItems?.result?.items.find(
				(item: any) => item.ParentCategoryName == productItems?.CategoryName
			);
			if (CategoryName?.ParentCategoryId) {
				dispatch(subCategories.list({
					url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories/list`,
					entity: 'categories',
					jsonData: {
						"Filters": [
							{
								"FieldName": "ParentCategoryId",
								"FilterOperatorId": 1,
								"FieldValue": CategoryName?.ParentCategoryId,
								"FieldType": "number"
							}
						],
					}
				}))
			}

		}

	}, [productItems?.CategoryName]);

	useEffect(() => {

	}, [count, selectedInput]);
	useEffect(() => {

	}, [selected])

	useEffect(() => {
		setRazorpaySettings(paymentMethodQuery?.result?.items?.RazorPayConfiguration);

	}, [paymentMethodQuery]);

	useEffect(() => {
		const gateways: any = []
		if (razorpaySettings?.RazorPay?.IsActive) {
			gateways.push({ Id: 10, title: 'Razorpay', detail: 'Razorpay' })
		}
		if (razorpaySettings?.CCAvenue?.IsActive) {

			gateways.push({ Id: 20, title: 'CC Avenue', detail: 'CC Avenue' })
		}
		if (razorpaySettings?.PhonePe?.IsActive) {
			gateways.push({ Id: 30, title: 'PhonePe', detail: 'PhonePe' })
		}
		setPaymentGateway(gateways);
	}, [razorpaySettings]);



	// Step 2: Submit Quotes
	const handleSaveQuote = async () => {

		if (
			!productItems?.CategoryName ||
			!productItems?.SubCategoryName ||
			!productItems?.ProductTypeName ||
			!productItems?.VehicleNumber ||
			!productItems?.VehicleYear ||
			!productItems?.VehicleModel ||
			!productItems?.VehicleBrand ||
			!quoteData?.date ||
			!SearchedLocation?.description ||
			!dropLocations?.description
		) {
			toast.error("All fields are required. Please fill in all the details.");
			return; // Stop further execution if validation fails
		}
		const fromAddressData = _.split(SearchedLocation?.description, ',');
		const toAddressData = _.split(dropLocations?.description, ',');
		const categoryName = categoryListItems?.result?.items.find(
			(item: any) => item.Id == productItems?.CategoryName
		);
		const valueData = {

			MobilityLeadId: createLead?.result[0] || '',
			RAPCustomerId: userInfo[0]?.Message?.Roles[0]?.Id,
			ScheduledDate: quoteData?.date,
			items: [
				{
					CategoryName: productItems?.CategoryName,
					SubCategoryName: productItems?.SubCategoryName || '',
					ProductTypeName: productItems?.ProductTypeName,
					VehicleNumber: productItems?.VehicleNumber,
					VehicleYear: productItems?.VehicleYear,
					VehicleModel: productItems?.VehicleModel,
					VehicleBrand: productItems?.VehicleBrand,
					VehicleChassisNumber: productItems?.VehicleChassisNumber
				}
			],

			fulfillment: {
				category_id: shippingTypesDetails?.result?.items[0]?.Id,
				start: {
					location: {
						gps: `${SearchedLocation?.lat} ,${SearchedLocation?.lng}`,
						address: {
							name: quoteData?.pickupName,
							building: quoteData?.startBuilding,
							locality: `${fromAddressData[0]},${fromAddressData[1]}`,
							city: SearchedLocation?.name,
							state: fromAddressData[3] || 'TamilNadu',
							country: 'India',
							area_code: SearchedLocation?.pincode || ''
						}
					},
					contact: {
						phone: quoteData?.pickupPhoneNumber,
						email: userInfo[0]?.Message?.Email
					}
				},
				end: {
					location: {
						gps: `${dropLocations?.lat} ,${dropLocations?.lng}`,
						address: {
							name: quoteData?.dropName,
							building: quoteData?.endBuilding,
							locality: `${toAddressData[0]},${toAddressData[1]}`,
							city: dropLocations?.name,
							state: toAddressData[3] || 'TamilNadu',
							country: 'India',
							area_code: dropLocations?.pincode || ''
						}
					},
					contact: {
						phone: quoteData?.dropPhoneNumber,
						email: ''
					}
				}
			}

		}
		dispatch(settings.set({
			valueData
		}))
		if (SearchedLocation?.description !== dropLocations?.description) {
			await dispatch(quotes.resetAction({ actionType: 'create' }))
			await dispatch(quotes.create({
				url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/sales/quotes`, entity: 'quotes',
				jsonData: {
					Context: {},
					Records: [
						valueData]
				}
			}))
			await setIsQuotes(true)
			await setIsButtonLoading(false)
		}

		else {
			setIsButtonLoading(false)
			toast.error("The Pickup and Drop addresses must be different.")
		}
	}

	useEffect(() => {

		if (isQuotes && quoteDetails?.isSuccess) {
			setSearchedLocation({
				name: '',
				lat: '',
				lng: '',
				pincode: '',
				description: ''
			})
			setDropLocations({
				name: '',
				lat: '',
				lng: '',
				pincode: '',
				description: ''
			})
			setIsQuotes(false)
			handleNext();
		}
	}, [isQuotes])



	// Step 3: Add Payment
	const handleOrder = async () => {
		await setIsButtonLoading(true)
		await dispatch(addPayment.update({
			url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/check-outs/add-payment`, entity: 'addPayment', jsonData: {

				Records: [{
					Context: {
						transaction_id: generateIds?.transaction_id,
						message_id: generateIds?.message_id,
					},
					Message: {
						Id: quoteDetails?.result?.Records[0]?.MobilityQuoteId,
						OwnerType: 'MobilityQuote',
						PaidAmount: quoteDetails?.result?.Records[0]?.quote?.breakup[0]?.price?.value,
						PaymentRemarks: 'Mobility',
						PaymentMethodId: selected, // Number(sessionStorage.getItem('paymentmethod')),
						PaymentGatewayId: paymentGateway[0]?.Id || 0,
					},
				}

				],
			}
		}))
		await dispatch(orders.resetAction({ actionType: 'create' }))
		await setIsPaymentAdded(true);

	};

	// Step 4: Confirm Mobility Order
	useEffect(() => {
		if (isPaymentAdded) {
			const orderData = {
				"StoreSalesChannelId": salesChannelId,
				"MobilityProductId": result?.quoteData?.mobilityProdcutId,
				"RAPCustomerId": quoteDetails?.result?.Records[0]?.RAPCustomerId || userInfo[0]?.Message?.Roles[0]?.Id,
				"IsUserHasSubscription": quoteDetails?.result?.Records[0]?.IsUserHasSubscription,
				"order": {

					"customer": {
						"id": userInfo[0]?.Message?.Roles[0]?.Id || '',
						"name": userInfo[0]?.Message?.FirstName || '',
						"phone": userInfo[0]?.Message?.PhoneNumber || '',
						"email": userInfo[0]?.Message?.Email || '',
						"vehicle": {
							"number": quoteDetails?.result?.Records[0]?.items[0]?.VehicleNumber,
							"chasis_number": quoteDetails?.result?.Records[0]?.items[0]?.VehicleChassisNumber,
							"brand": quoteDetails?.result?.Records[0]?.items[0]?.VehicleBrand,
							"model": quoteDetails?.result?.Records[0]?.items[0]?.VehicleModel,
							"year": quoteDetails?.result?.Records[0]?.items[0]?.VehicleYear
						}
					},
					"provider": {

					},
					"service": [
						{
							"id": 0,
							"name": "Asstance",
							"quote": {
								"price": quoteDetails?.result?.Records[0]?.quote?.breakup[0]?.price?.value,
								"ScheduledDate": quoteData?.date,
								"breakup": [
									{
										"id": 0,
										"title": "Assitance",
										"price": quoteDetails?.result?.Records[0]?.quote?.breakup[0]?.price?.value
									}
								]
							}
						}
					],
					"fulfillments": [
						{
							"start": {
								"customer": {
									"id": userInfo[0]?.Message?.Roles[0]?.Id || '',
									"name": result?.valueData?.fulfillment?.start?.location?.address?.name,
									"phone": result?.valueData?.fulfillment?.start?.contact?.phone,
									"email": result?.valueData?.fulfillment?.start?.contact?.email,
									"vehicle": {
										"number": result?.valueData?.items[0]?.VehicleNumber,
										"chasis_number": result?.valueData?.items[0]?.VehicleChassisNumber,
										"brand": result?.valueData?.items[0]?.VehicleBrand,
										"model": result?.valueData?.items[0]?.VehicleModel,
										"year": result?.valueData?.items[0]?.VehicleYear
									}
								},
								"person": {
									"name": result?.valueData?.fulfillment?.start?.location?.address?.name
								},
								"location": {
									"gps": result?.valueData?.fulfillment?.start?.location?.gps,
									"address": {
										"name": result?.valueData?.fulfillment?.start?.location?.address?.name,
										"building": result?.valueData?.fulfillment?.start?.location?.address?.building,
										"locality": result?.valueData?.fulfillment?.start?.location?.address?.locality,
										"city": result?.valueData?.fulfillment?.start?.location?.address?.city,
										"state": result?.valueData?.fulfillment?.start?.location?.address?.state,
										"country": result?.valueData?.fulfillment?.start?.location?.address?.country,
										"area_code": result?.valueData?.fulfillment?.start?.location?.address?.area_code
									}
								},
								"contact": {
									"phone": result?.valueData?.fulfillment?.start?.contact?.phone,
									"email": result?.valueData?.fulfillment?.start?.contact?.email
								},
								"instructions": {
									"short_desc": "string",
									"long_desc": "string",
									"images": [
										"string"
									]
								}
							},
							"end": {
								"customer": {
									"id": userInfo[0]?.Message?.Roles[0]?.Id,
									"name": result?.valueData?.fulfillment?.end?.location?.address?.name,
									"phone": result?.valueData?.fulfillment?.end?.contact?.phone,
									"email": result?.valueData?.fulfillment?.start?.contact?.email,
									"vehicle": {
										"number": result?.valueData?.items[0]?.VehicleNumber,
										"chasis_number": result?.valueData?.items[0]?.VehicleChassisNumber,
										"brand": result?.valueData?.items[0]?.VehicleBrand,
										"model": result?.valueData?.items[0]?.VehicleModel,
										"year": result?.valueData?.items[0]?.VehicleYear
									}
								},
								"person": {
									"name": result?.valueData?.fulfillment?.end?.location?.address?.name,
								},
								"location": {
									"gps": result?.valueData?.fulfillment?.end?.location?.gps,
									"address": {
										"name": result?.valueData?.fulfillment?.end?.location?.address?.name,
										"building": result?.valueData?.fulfillment?.end?.location?.address?.building,
										"locality": result?.valueData?.fulfillment?.end?.location?.address?.locality,
										"city": result?.valueData?.fulfillment?.end?.location?.address?.city,
										"state": result?.valueData?.fulfillment?.end?.location?.address?.state,
										"country": result?.valueData?.fulfillment?.end?.location?.address?.country,
										"area_code": result?.valueData?.fulfillment?.end?.location?.address?.area_code
									}
								},
								"contact": {
									"phone": result?.valueData?.fulfillment?.end?.contact?.phone,
									"email": result?.valueData?.fulfillment?.end?.contact?.email
								},
								"instructions": {
									"short_desc": "string",
									"long_desc": "string",
									"images": [
										"string"
									]
								}
							}
						}
					],
				},
				"job": {

				},
				"feedback": {

				}
			}

			dispatch(orders.create({
				url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/orders/confirm`,
				entity: 'orderCreate',
				jsonData: orderData
			})).then(() => {
				setIsButtonLoading(false)
				setIsOrderPlaced(true);
			}).then(() => {
				setSearchedLocation({
					name: '',
					lat: '',
					lng: '',
					pincode: '',
					description: ''
				})
				setDropLocations({
					name: '',
					lat: '',
					lng: '',
					pincode: '',
					description: ''
				})

			})
		}
	}, [isPaymentAdded])

	// Start- ccAvenue function
	const encrypt1 = (plainText: string, workingKey: string): string => {
		// Create an MD5 hash of the workingKey
		const key = CryptoJS.MD5(workingKey).toString(CryptoJS.enc.Hex);

		// Initialization vector (IV)
		const iv = CryptoJS.enc.Hex.parse('000102030405060708090a0b0c0d0e0f');

		// Encrypt the plainText
		const encrypted = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Hex.parse(key), {
			iv: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		});

		// Return the encrypted text in hex format
		return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
	};

	const handeCCAvenuePayment = (orderId: any) => {
		const workingKey =
			razorpaySettings.CCAvenue?.WorkingKey; //Put in the 32-Bit key shared by CCAvenues.
		const accessCode =
			razorpaySettings.CCAvenue?.AccessCode;
		const merchantId =
			razorpaySettings.CCAvenue?.MerchantId;

		const companyName = localStorage.getItem("CompanyName");
		const channelId = storePersist.get("accessTokenMetadata").current?.TokenMetadata?.SalesChannelId;
		const tenant = companyName; //getBusinessCompanyName();


		const ccAvenueData = {
			merchant_id: merchantId,
			order_id: orderId,
			currency: 'INR',
			amount: quoteDetails?.result?.quote?.breakup[0]?.price?.value, //Total Price,
			//   ENABLE WHILE TESTING LOCALLY. NEEDS TO BE RUN ALONG WITH PAYMENTS REPO.
			//   redirect_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,
			//   cancel_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,

			// ENABLE FOR PRODUCTION
			redirect_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userInfo[0]?.Message?.PhoneNumber}/ccavResponseHandler`,
			cancel_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userInfo[0]?.Message?.PhoneNumber}/ccavResponseHandler`,
			language: 'EN',
			billing_name: result?.valueData?.fulfillment?.start?.location?.address?.name,
			billing_address: result?.valueData?.fulfillment?.start?.location?.address?.locality,
			billing_city: result?.valueData?.fulfillment?.start?.location?.address?.city,
			billing_state: result?.valueData?.fulfillment?.start?.location?.address?.state,
			billing_zip: result?.valueData?.fulfillment?.start?.location?.address?.area_code,
			billing_country: result?.valueData?.fulfillment?.start?.location?.address?.country,
			billing_tel: userInfo[0]?.Message?.PhoneNumber,
			billing_email: userInfo[0]?.Message?.Email,
			delivery_name: result?.valueData?.fulfillment?.end?.location?.address?.name,
			delivery_address: result?.valueData?.fulfillment?.end?.location?.address?.locality,
			delivery_city: result?.valueData?.fulfillment?.end?.location?.address?.city,
			delivery_state: result?.valueData?.fulfillment?.end?.location?.address?.state,
			delivery_zip: result?.valueData?.fulfillment?.end?.location?.address?.area_code,
			delivery_country: result?.valueData?.fulfillment?.end?.location?.address?.country,
			merchant_param1: tenant, //getOrganizationName(),
			merchant_param2: tenantId,
			merchant_param3: `${window.location.hostname}`,
			merchant_param4: "order-details",
			merchant_param5: '',
			integration_type: 'iframe_normal',
			// promo_code:'PROMO8513',
			customer_identifier: userInfo[0]?.Message?.Email,
		};
		const body = queryString.stringify(ccAvenueData);

		const encRequest1 = encrypt1(body, workingKey);
		// let URL = `https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;
		let URL = `https://${MODE}.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;

		window.location.href = URL;
		// router.push(URL);
	}

	useEffect(() => {
		if (isOrderPlaced) {
			switch (selected) {
				case 10: //cash payment
					navigate(`/order-details`)
					break;
				case 20: //online
					switch (paymentGateway[0]?.Id) {
						case 10: //razorpay
							// handeRazorpay()
							break;
						case 20: //ccavenue
							handeCCAvenuePayment(orderDetails?.result?.items[0])
							break;
						case 30: //phonepe
							break;
						default:
					}


					break;
				case 30: //wallet
					break;
			}

		}
	}, [isOrderPlaced])


	useEffect(
		() => {



			generateIdValue()
			dispatch(productTypes.list({ url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/product-types/list`, entity: 'productTypes', jsonData: {} }))
				.then(() => {
					dispatch(shippingTypes.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`, entity: 'shippingTypes', jsonData: {} }))
				}).then(() => {
					dispatch(categories.list({
						url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories/list`,
						entity: 'categories',
						jsonData: {}
					}));
				}).then(() => {
					dispatch(paymentMethods.query({
						url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/configuration/payment-management/payment-methods/query-by-tenants`, entity: 'paymentMethods', jsonData:
							{ "Tenants": [{ "Id": tenantId }] }
					}))
				}).then(() => {
					dispatch(channel.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/channels/list`, entity: 'channels', jsonData: {} }))
				})
		},
		[]
	);

	const handleBookLater = async () => {
		//await dispatch(leads.resetAction({ actionType: 'create' }))
		await dispatch(quotes.resetAction({ actionType: 'create' }))
		await setSearchedLocation({
			name: '',
			lat: '',
			lng: '',
			pincode: '',
			description: ''
		})
		await setDropLocations({
			name: '',
			lat: '',
			lng: '',
			pincode: '',
			description: ''
		})

		await setProductItems([]);
		await SetQuoteData({})
		await setActiveStep(0)
		await navigate('/')
	}

	return (
		<div className="flex flex-col items-center w-auto px-5 overflow-auto h-auto">

			<>
				{width && width < 720 ? <div className="flex justify-center items-center pt-8 px-4 sm:px-0">
					<div className="my-2 mx-auto max-w-sm w-full sm:w-auto">
						<div className={`rounded-lg shadow-lg flex flex-col w-full sm:w-[900px]  h-[80vh] p-5 overflow-auto bg-scroll`}>
							<div className="flex items-start justify-between w-full border-b p-2">
								<div className="flex w-full flex-col items-center justify-between text-xl">
									{tutorialSteps[activeStep].title}
								</div>
							</div>
							<div className="w-full flex flex-col sm:flex-row p-3 border-b py-5">
								<div className="flex flex-col w-full sm:w-3/4 space-y-3">
									{tutorialSteps[activeStep].component}
								</div>
							</div>

							<div className="w-full flex flex-col sm:flex-row p-3">
								<div className="w-full sm:w-1/4">
									{/* Placeholder for spacing */}
								</div>
								{tutorialSteps[activeStep].id === maxSteps ? (
									<div className="w-full sm:w-3/4">
										<div className="flex flex-row justify-end items-center space-x-2">
											<button disabled={activeStep === 1} onClick={handleBack} className={` border-x border-y px-2 py-1 text-sm font-bold`}>
												Back
											</button>
											<button onClick={() => dispatch(settings.set({ getQuote: 'close' }))} className={`border-x border-y px-2 py-1 text-sm font-bold`}>
												Book Later
											</button>
											<button onClick={handleOrder} className={` border-x border-y px-2 py-1 text-sm font-bold`}>
												Confirm Booking
											</button>
										</div>
									</div>
								) : (
									<>
										<div className="w-full sm:w-3/4">
											<div className="flex flex-row justify-end items-center space-x-2">
												{activeStep !== 0 && (
													<button onClick={handleBack} className={` border-x border-y px-2 py-1 text-sm font-bold`}>
														Back
													</button>
												)}
												{/* {tutorialSteps[activeStep].id === 1 && (
													<button onClick={handleLeadSubmit} disabled={activeStep === maxSteps - 1} className={` border-x border-y px-2 py-1 text-sm font-bold`}>
														Next
													</button>
												)} */}
												{tutorialSteps[activeStep].id !== 1 && tutorialSteps[activeStep].id !== 3 && (
													<button onClick={handleNext} disabled={activeStep === maxSteps - 1} className={` border-x border-y px-2 py-1 text-sm font-bold`}>
														Next
													</button>
												)}
												{tutorialSteps[activeStep].id === 3 && (
													<button onClick={handleSaveQuote} disabled={activeStep === maxSteps - 1} className={` border-x border-y px-2 py-1 text-sm font-bold`}>
														Next
													</button>
												)}
											</div>
										</div>
									</>
								)}
							</div>
						</div>
					</div>
				</div> :
					<div className="flex justify-center items-center w-full bg-slate-50">
						<div className=" my-2 mx-auto w-full">
							<div className={` rounded-lg shadow-lg flex flex-col w-full p-5`}>
								<div className="flex items-start justify-between w-full border-b p-2 ">
									<div className="flex w-full flex-col items-center justify-between text-xl" >
										{tutorialSteps[activeStep].title}
									</div>
								</div>
								<div className="w-full flex flex-row justify-center items-center border-b p-2 py-5">
									<div className="flex flex-col w-3/4 space-y-3">
										{tutorialSteps[activeStep].component}
									</div>
								</div>

								<div className="w-full flex flex-row p-3 ">

									{tutorialSteps[activeStep].id === maxSteps ? (
										<div className="w-full">
											<div className="flex flex-row justify-end items-center space-x-2">
												<button disabled={activeStep === 1} onClick={handleBack} className={`bg-primary text-light border-x border-y  px-2 py-1 text-sm font-bold`}>
													Back
												</button>
												<button onClick={handleBookLater} className={`bg-primary text-light border-x border-y  px-2 py-1 text-sm font-bold`}>
													Book Later
												</button>
												<button onClick={handleOrder} disabled={isButtonLoading} className={`${isButtonLoading ? 'bg-primary bg-opacity-70 w-44 ' : 'bg-primary '}  text-light items-center justify-center flex flex-row   border-x border-y  px-2 py-1 text-sm font-bold `}>
													Confirm Booking
													{isButtonLoading && <div className={`${isButtonLoading ? 'visible' : 'invisible'}`}>
														<RotatingLines
															visible={true}
															width={'20'}
															strokeColor="#fff"
															strokeWidth="6"
															animationDuration="0.75"
															ariaLabel="rotating-lines-loading"
														/>
													</div>}
												</button>
											</div>
										</div>) : (
										<>
											<div className="w-full">

												<div className="flex flex-row justify-end items-center space-x-2">
													{activeStep !== 0 && (<button onClick={handleBack} className={`bg-primary text-light border-x border-y  px-2 py-1 text-sm font-bold`}>
														Back
													</button>)}

													{tutorialSteps[activeStep].id !== 3 && tutorialSteps[activeStep].id !== 5 && (<button onClick={handleNext} disabled={activeStep === maxSteps - 1} className={`bg-primary text-light border-x border-y  px-2 py-1 text-sm font-bold`}>
														Next
													</button>)}

													{tutorialSteps[activeStep].id === 3 && (<button onClick={handleSaveQuote} disabled={activeStep === maxSteps - 1} className={`${isButtonLoading ? 'bg-primary bg-opacity-70 w-20 ' : 'bg-primary '}  text-light items-center justify-center flex flex-row   border-x border-y  px-2 py-1 text-sm font-bold `}>
														Next
														{isButtonLoading && <div className={`${isButtonLoading ? 'visible' : 'invisible'}`}>
															<RotatingLines
																visible={true}
																width={'20'}
																strokeColor="#fff"
																strokeWidth="6"
																animationDuration="0.75"
																ariaLabel="rotating-lines-loading"
															/>
														</div>}
													</button>)}

												</div>
											</div>
										</>
									)}

								</div>
							</div>
						</div>
					</div>

				}
			</>
		</div>

	);
};

export default HomeOrderBookings;


